const REGEX_TO_EXTRACT_NUMBERS = /\D/g;

export const transformAmount = (input: string | number | undefined | null) => {
  if (input === undefined || input === null) return 0;

  const stringInput = String(input) || "0";
  return Number(stringInput.replace(REGEX_TO_EXTRACT_NUMBERS, ""));
};

export const isBeforePriceLowerThanCurrentPrice = (
  beforePrice: string | number | undefined | null,
  currentPrice: string | number | undefined | null,
): boolean => transformAmount(beforePrice) < transformAmount(currentPrice);

export const isBeforePriceLessThanOrEqualToCurrentPrice = (
  beforePrice: string | number | undefined | null,
  currentPrice: string | number | undefined | null,
): boolean => transformAmount(beforePrice) <= transformAmount(currentPrice);
